import React, { memo, useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './WpTurnStart.module.less';

import { PCStoreJsBridge } from '../../nativeapi';
import { logging } from '../../actions/log';
import { updateShowWpTurnStart } from '../../actions/wallpaper';
import Toast from '../../components/Toast/Toast';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectWallpaper = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper,
);

export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const { wpShowTurnStart } = useSelector(selectWallpaper);

  useEffect(() => {
    loggingFunc('Wallpaper', 'P_Wallpaper_LoopStart');
  }, []);

  const loggingFunc = useCallback(
    (category, action) => {
      dispatch(
        logging({
          category: category || 'Wallpaper',
          action: action || 'P_Wallpaper_LoopStart',
          label: '',
          param2: {
            source: logInfoData?.source,
            source_p: logInfoData?.source_p,
            source_pp: logInfoData?.source_pp,
            wpType: wpShowTurnStart?.wpType || 1, // 1: 单张壁纸，2：壁纸包 3: 仅仅订阅
          },
        }),
      );
    },
    [logInfoData, wpShowTurnStart],
  );

  const handleDialogClose = useCallback(
    flag => {
      // 点击确定
      if (
        flag &&
        wpShowTurnStart?.callbackTurnStart &&
        typeof wpShowTurnStart?.callbackTurnStart === 'function'
      ) {
        let switchTurn = {};
        if (window?.external?.get_wallpaper_carousel_switch_info) {
          switchTurn = JSON.parse(window.external.get_wallpaper_carousel_switch_info() || '{}');
        }
        // 去开启轮播
        PCStoreJsBridge.switchWpOpenTurn({
          switch: 'on',
          duration: switchTurn?.duration || 5,
        }).then(res => {
          if (res) {
            Toast.success({
              content: '开启壁纸轮播成功！',
            });
            dispatch(
              logging({
                category: 'Wallpaper',
                action: 'R_Wallpaper_Loop_Start',
                label: '',
                param2: {
                  source: logInfoData?.source,
                  source_p: logInfoData?.source_p,
                  source_pp: logInfoData?.source_pp,
                  Looptype: 1,
                },
              }),
            );
          }
        });
        // // 回调函数
        // if (
        //   wpShowTurnStart?.callbackTurnStart &&
        //   typeof wpShowTurnStart?.callbackTurnStart === 'function'
        // ) {
        //   wpShowTurnStart.callbackTurnStart(true);
        // }
      }
      setTimeout(() => {
        dispatch(
          updateShowWpTurnStart({
            show: false,
          }),
        );
      }, 100);
    },
    [wpShowTurnStart],
  );

  return (
    <div className={styles.dialog_box}>
      <div className={styles.dialog_cont}>
        <div className="dialog_header">
          <div className="dialog_header_text" />
          <div
            className="dialog_header_close iconfont icon-opt_close"
            onClick={() => {
              handleDialogClose();
            }}
          />
        </div>
        <div className="dialog_content">
          <div className="dialog_title">
            <div className="dialog_title_icon" />
            <div className="dialog_title_text">已为您开启壁纸轮播功能</div>
          </div>
          <div className="dialog_center">
            <div className="dialog_center_img" />
            <div className="dialog_center_desc">
              您可在 <span>壁纸频道 → 我的</span> 进行相关设置
            </div>
          </div>
          <div className="dialog_opt">
            <div
              className={'dialog_btn_sure'}
              onClick={() => {
                handleDialogClose(true);
              }}
            >
              确定
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
